export default __webpack_public_path__ + "static/cygnilabs-082f7e55b26e245b8df36df14ea4bf16.png";